import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class ProgrammableLogicController_ds_connectors_gridService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }


  public async getList($inParams: { fullTextSearch?: string, $top?: number, $skip?: number }): Promise<{ result?: { name?: string, warehouseId?: number, type?: string, projectId?: number, orderClassId?: number }[], totalCount?: number }> {
    let $url = `${environment.backendUrl}api/ProgrammableLogicController/datasources/ds_connectors_grid/getList`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }
  public async getByKeys($inParams: { fullTextSearch?: string, $keys: string[] }): Promise<{ result?: { name?: string, warehouseId?: number, type?: string, projectId?: number, orderClassId?: number }[] }> {
    const $missingRequiredInParams = [];
    if (isNil($inParams.$keys)) {
      $missingRequiredInParams.push('\'$keys\'');
    }
    if ($missingRequiredInParams.length) {
    }
    let $url = `${environment.backendUrl}api/ProgrammableLogicController/datasources/ds_connectors_grid/getByKeys`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }

    
    hasMissingRequiredInParams($inParams: { 
      fullTextSearch?: string    }) {
      return false;
    }
}
